// 设备管理接口
import request from '@/utils/request'
//获取训练计划
// export const gettrainManagelist = (params: any) =>
//   request({
//     url: '/api/trainplanManagelist',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const gettrainManagelist = (params: any) =>
  request({
    url: '/trainingPlan/getTrainPlanInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

// export const addTrain = (params: any) =>
//   request({
//     url: '/api/trainplanManage',
//     method: 'post',
//     data: params,
//   })
//新增训练计划
export const addTrain = (params: any) =>
  request({
    url: '/trainingPlan/addTrainPlan',
    method: 'post',
    data: params,
    // headers: {
    //   'Content-Type': 'application/json'
    // }
  })
export const traindetail = (params: any) =>
  request({
    url: `/trainingPlan/getTranPlanDetailInfo`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const traindetail = (params: any) =>
//   request({
//     url: `/api/trainplanManage/:id`,
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const updateinfo = (params: any) =>
  request({
    url: `/trainingPlan/updateTrainPlan`,
    method: 'PUT',
    data: params,
  })
export const downloadFile = (params: any) =>
  request({
    url: `/trainingPlan/download`,
    method: 'get',
    params
  })


export const getorglist = (params: any) =>
  request({
    url: `/users/getOrganInfoByID`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const gettrainlist = (params: any) =>
//   request({
//     url: `/api/trainplanManage/:detail`,
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const gettrainlist = (params: any) =>
  request({
    url: `/trainingPlan/getTrainInfoById`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const exportresult = (params: any) =>
  request({
    url: `/api/exportresult`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const traindetaillist = (params: any) =>
  request({
    url: `/trainingPlan/getTranPlanDetailInfoAndOrganName`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })